import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { ApiAction, createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getVirtualEvent } from 'modules/virtualClassrooms/common/api/managerService'
import { EventDetailsState, ApiVirtualEventDetailsResponse } from './types'

const initialState: EventDetailsState = {
  eventDetailsData: {},
}

const eventDetailsSlice = createSlice({
  name: 'virtualClassroomManagerEventDetails',
  initialState,
  reducers: {
    eventDetailsLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiVirtualEventDetailsResponse>>
    ) {
      state.eventDetailsData = action.payload
    },
    clearEventDetailsData(state) {
      state.eventDetailsData = initialState.eventDetailsData
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { eventDetailsLoaded } = eventDetailsSlice.actions
export const { clearEventDetailsData } = eventDetailsSlice.actions

export default eventDetailsSlice.reducer

export const loadEventDetailsData = (eventId: Guid): ApiAction => {
  return createApiAction({
    apiCalls: {
      details: () => getVirtualEvent(eventId),
    },
    payloadAction: eventDetailsLoaded,
  })
}

export const reloadEventDetailsData = (eventId: Guid): ApiAction => {
  return createApiAction({
    apiCalls: {
      details: () => getVirtualEvent(eventId),
    },
    payloadAction: eventDetailsLoaded,
    getResultToKeep: ({ virtualClassroomManagerEventDetails }) =>
      virtualClassroomManagerEventDetails.eventDetailsData.result,
    shouldShowGlobalLoading: true,
  })
}
